import { GenerateTestDataButton } from './GenerateTestDataButton';
import { generateProductFeaturesTestData } from '../utils/productFeaturesTestDataGenerator';

export const GenerateProductFeaturesButton = () => {
  return (
    <GenerateTestDataButton
      label="Generate Test Features"
      generateFunction={generateProductFeaturesTestData}
      queryKey={['product-features']}
    />
  );
};